import React from 'react';
import { Box, Button, Chip, Stack } from '@mui/material';
import DownloadIcon from '@mui/icons-material/Download';

const pluralize = (count, singular, plural) => `${count} ${count === 1 ? singular : plural}`;

const AppSheetOrderItemsToolbar = ({
  summary,
  onExport,
  accountLabel = 'accounts',
  itemLabel = 'order item',
  itemLabelPlural = 'order items',
}) => {
  const accountCount = summary?.accounts ?? 0;
  const itemCount = summary?.orderItems ?? 0;
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%', gap: 2, flexWrap: 'wrap' }}>
      <Stack direction="row" spacing={1} flexWrap="wrap">
        <Chip size="small" label={pluralize(accountCount, accountLabel.replace(/s$/, ''), accountLabel)} variant="outlined" />
        <Chip size="small" label={pluralize(itemCount, itemLabel, itemLabelPlural)} variant="outlined" />
        {summary?.filteredOrderItems != null ? (
          <Chip size="small" label={`${summary.filteredOrderItems} filtered`} variant="outlined" />
        ) : null}
      </Stack>
      <Stack direction="row" spacing={1}>
        <Button
          variant="outlined"
          size="small"
          startIcon={<DownloadIcon />}
          onClick={onExport}
        >
          Export CSV
        </Button>
      </Stack>
    </Box>
  );
};

export default AppSheetOrderItemsToolbar;
